import React, { Component } from 'react'
import './number.css'

class Input extends Component {

    handleInput(e){  
        if(this.props.onSubmit){
            this.props.onSubmit(e.target.value)
        }
    }
      
    render () {
        return (
          <div>
            <label>台幣(TWD)</label>
            <input type='number' onChange={this.handleInput.bind(this)} />
          </div>
        )
    }
}
  
  class PercentageShower extends Component {
    constructor(){
      super()
      this.state={
        UTC:'',
        USDTWD:'',
        USDJPY:'',
        USDCNY:'',
        USDKRW:''
      }
    }
    componentDidMount = () => {
      fetch('http://out.6-17.net/a.php')
      .then((resp) => resp.json())
      .then(data => {         
        this.setState({
          UTC:data.USDTWD.UTC,
          USDTWD: data.USDTWD.Exrate,
          USDJPY: data.USDJPY.Exrate,
          USDCNY: data.USDCNY.Exrate,
          USDKRW: data.USDKRW.Exrate,
        })
      })
      
      
    }
    render () {        
        let outUSDTWD = (this.props.number/this.state.USDTWD).toFixed(2)
        let outUSDJPY = (outUSDTWD*this.state.USDJPY).toFixed(2)
        let outUSDCNY = (outUSDTWD*this.state.USDCNY).toFixed(2)
        let outUSDKRW = (outUSDTWD*this.state.USDKRW).toFixed(2)
        return (<div>
            <h3><label>=美金   </label>{outUSDTWD}</h3>
            <h3><label>=日元   </label>{outUSDJPY}</h3>
            <h3><label>=人民幣 </label>{outUSDCNY}</h3>
            <h3><label>=韓元   </label>{outUSDKRW}</h3>
            <p>日期：{this.state.UTC}</p>
            </div>)
    }
  }
  
  class PercentageApp extends Component {
    constructor(){
        super()
        this.state = {
          number: 0
        }
      }
      
      handleInput(e){
        if (!e) return
        this.setState({
            number: e
        })
      }
      
      render () {
        return (
          <div className="wrapper">
            <h1>台幣即時匯率</h1>
            <Input onSubmit={this.handleInput.bind(this)} />
            <PercentageShower number={this.state.number} />
          </div>
        )
      }
  }

  export default PercentageApp


// WEBPACK FOOTER //
// ./src/_/number.js